import * as actionTypes from '../actions/actionTypes';

export default function glsAgent(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_GLS_AGENT: {
      return action.glsAgentData;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/glsAgentReducer.js